import {BaseContainerModel} from '../../base-container.model';
import { bl_fi_pns_settlement_link_RowClass } from '../../../dbschema/bl_fi_pns_settlement_link.model';

export class PNSSettlementContainerModel extends BaseContainerModel {
  bl_fi_pns_settlement_link: bl_fi_pns_settlement_link_RowClass = new bl_fi_pns_settlement_link_RowClass();
}
